import { SettingsTabs } from "@/components/settings/SettingsTabs";
import { useTheme } from "@/context/ThemeContext";
import { useIsMobile } from "@/hooks/use-mobile";
import BtnNavigateBack from "@/components/ui/btn_navigate_back";
import { settingsLabels } from "@/i18n";
import { useLanguage } from "@/context/LanguageContext";
import { useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useNativePlatform } from "@/hooks/useNativePlatform";
import { useShowNavigateBack } from "@/hooks/useShowNavigateBack";


const Settings = () => {
  const { theme } = useTheme();
  const isDark = theme === "dark";
  const isMobile = useIsMobile();
  const { isNative } = useNativePlatform();
  const showPageBack = useShowNavigateBack();
  const { language } = useLanguage();
  const labels = settingsLabels(language);
  const [searchParams] = useSearchParams();
  const [defaultTab, setDefaultTab] = useState<string>("");

  useEffect(() => {
    const tabParam = searchParams.get("tab");
    setDefaultTab(tabParam ?? "");
  }, [searchParams]);

  return (
    <>
      {showPageBack && (
        <div className="container mx-auto max-w-4xl pt-6 pb-2 px-4 native-page-back">
          <BtnNavigateBack />
        </div>
      )}
      <div
        className={`container mx-auto min-w-0 max-w-4xl ${
          isNative ? "px-3 py-1 pb-2" : isMobile ? "p-2 pt-4 pb-16" : "px-4 pb-4 pt-0"
        }`}
      >
        <h1
          className={`text-2xl ${isNative ? "mb-2 mt-0" : "mb-4"} font-bold text-center ${
            isDark ? "text-white" : "text-gray-800"
          }`}
        >
          {labels.title}
        </h1>

        <SettingsTabs defaultTab={defaultTab} />
      </div>
    </>
  );
};

export default Settings;
